
import {ComponentType, ReactElement} from 'react'
import {flowRight as compose} from 'lodash'
import {I18nContextValues, Trans, withNamespaces} from 'react-i18next'
import withStyles, {StyledComponentProps} from '@material-ui/core/styles/withStyles'
import {Grid, Typography} from '@material-ui/core'
import messages from '../../../../../../../assets/messages'
import NotificationBar from '../../../../../../Common/NotificationBar'
import {AlertDialog} from '../../../../../../Common/Dialog'
import {BrokereeCopyTradingOffer} from '../../../../types'
import {styles} from './styles'

type UnsubscribeAlertDialogPropsBase = {
  isOpen: boolean
  offer: BrokereeCopyTradingOffer | null
  errorMessage: string | null
  isLoading: boolean
  onAgree: () => void
  onDisagree: () => void
}

type UnsubscribeAlertDialogProps = UnsubscribeAlertDialogPropsBase & StyledComponentProps & I18nContextValues

const Component = (props: UnsubscribeAlertDialogProps): ReactElement => {
  const {classes = {}, t, offer, errorMessage, isOpen, isLoading, onAgree, onDisagree} = props

  const {performanceFee = 0, name = ''} = offer ?? {}

  const hasPerformanceFee = performanceFee > 0

  const strategyTranslationKey = hasPerformanceFee ? 'requestStopCopyTradingFeeTitle' : 'requestStopCopyTradingText'
  const feeNotificationTranslationKeys = ['requestStopCopyTradingFeeText', 'requestStopCopyTradingFeeText2', 'requestStopCopyTradingFeeText3']

  return (
    <AlertDialog
      open={isOpen}
      title={
        <Typography variant='body1' className={classes.title}>
          <Trans {...messages.requestStopCopyTradingTitle}
            components={[<span className={classes.highlight}>stop copying</span>,]}
          />
        </Typography>
      }
      agreeText={t(messages.stopCopying.i18nKey, messages.stopCopying.defaults)}
      disagreeText={t(messages.cancel.i18nKey, messages.cancel.defaults)}
      buttonLoading={isLoading}
      buttonStatus={errorMessage != null ? 'failure' : null}
      onAgree={onAgree}
      onDisagree={onDisagree}
      onClose={onDisagree}
    >
      <Grid container direction="row" alignContent="center" justifyContent="center">
        <Grid item xs={12}>
          <Typography variant='body1'>
            <Trans {...messages[strategyTranslationKey]}
              values={{strategy: name}}
              components={[<span className={classes.emphasize}>strategy</span>]}
            />
          </Typography>
        </Grid>
        {hasPerformanceFee ? (
          <>
            <ol className={classes.list}>
              {feeNotificationTranslationKeys.map((key) => (
                <li key={key} className={classes.listItem}>
                  <Typography variant='body1'>
                    <Trans {...messages[key]}
                      values={{strategy: name}}
                      components={[<span className={classes.emphasize}>strategy</span>]}
                    />
                  </Typography>
                </li>
              ))}
            </ol>
            <NotificationBar status="warning" noMargin>
              <Trans {...messages.requestStopCopyTradingFeeWeekend} />
            </NotificationBar>
          </>
        ) : null}
      </Grid>
      {errorMessage != null ? <NotificationBar status="error">{errorMessage}</NotificationBar> : null}
    </AlertDialog>
  )
}

export const UnsubscribeAlertDialog: ComponentType<UnsubscribeAlertDialogPropsBase> = compose(
  withStyles(styles),
  withNamespaces(),
)(Component)
